// 实勘接口
import { get } from '~/assets/js/api/methods'

import apiList from '~/api.config.js'
// homeClient客户端, testwikidatacenter服务端
const { testwikidatacenter, homeClient } = apiList

export default (axios) => ({
  init: (params = {}) => get(axios, `${testwikidatacenter}/wikifxweb-v1/survey/list/index/init-v1`, params), // init初始化
  switchInit: (params = {}) => get(axios, `${homeClient}/wikifxweb-v1/survey/list/index/more-v1`, params), // tabs切换
  detailsInit: (params = {}) => get(axios, `${testwikidatacenter}/wikifxweb-v1/survey/detail/index/init-v1`, params), // 详情页初始化
  getExpoList: (params = {}) => get(axios, `${testwikidatacenter}/wikifxweb-v1/survey/list/exhibitionhall-v1`, params) // 获取某个交易商下的展会实勘列表
})
